export default "__VITE_PUBLIC_ASSET__edb21a73__"